import { render, staticRenderFns } from "./doctorManageDetail.vue?vue&type=template&id=e533f734&scoped=true"
import script from "./doctorManageDetail.vue?vue&type=script&lang=js"
export * from "./doctorManageDetail.vue?vue&type=script&lang=js"
import style0 from "./doctorManageDetail.vue?vue&type=style&index=0&id=e533f734&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e533f734",
  null
  
)

export default component.exports